import { IBase } from "./Base";
import { ISkill } from "./Skills.type";
import { IUser } from "./User.types";

export interface IEndorsement extends IBase {
  skill: ISkill;
  skilledUser: IUser;
  endorserUser: IUser;
  comment?: string;
  active: boolean;
  type?: EEndorsementTypeEnum;
}

export class IUserEndorsementResult {
  times: number;
  skill: ISkill;
  userEndorsements: IEndorsement[];

  constructor(times: number, skill: ISkill, userEndorsements: IEndorsement[]) {
    this.times = times;
    this.skill = skill;
    this.userEndorsements = userEndorsements;
  }
}

export enum EEndorsementTypeEnum {
  SAME_PROJECT = "SAME_PROJECT",
  MEMBER_TO_LEADER = "MEMBER_TO_LEADER",
  LEADER_TO_MEMBER = "LEADER_TO_MEMBER"
}
